import AppRouter from './components/AppRouter/AppRouter';


function App() {
  return (
    <div>
      <AppRouter/>
    </div>
  );
}

export default App;
